var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBodyWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "110px",
    viewBox: "0 0 147 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C837F923-660F-4F96-A444-8357CA5A9D9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.-side-effects",
    transform: "translate(-1203.000000, -649.000000)",
    strokeWidth: 4.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(1206.000000, 652.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1581,51.6423 C29.67,60.7719 29.094,75.0537 38.6745,103.9233",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.16893,51.64203 C111.65763,60.77193 112.23393,75.05343 102.65223,103.92333",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.66335,
    y1: 103.92318,
    x2: 70.66335,
    y2: 82.65888,
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.80439,51.88929 C33.80439,51.88929 66.86919,64.58439 107.52249,51.88929",
    id: "Stroke-7",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.81746,60.84738 C31.81746,60.84738 50.45706,69.56208 64.66356,80.53398 C66.83856,82.21428 68.05446,82.31478 70.66326,82.65888 C73.27386,82.31478 74.48976,82.21428 76.66296,80.53398 C90.87156,69.56208 109.50906,60.84738 109.50906,60.84738",
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.81746,
    y1: 21.5052,
    x2: -0.00024,
    y2: 21.4872,
    id: "Stroke-11",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.50125,
    y1: 30.02592,
    x2: -0.00015,
    y2: 21.48732,
    id: "Stroke-13",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.00012,
    y1: 21.48732,
    x2: 8.50128,
    y2: 12.93072,
    id: "Stroke-15",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.50927,
    y1: 21.4674,
    x2: 141.32667,
    y2: 21.4674,
    id: "Stroke-17",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.82371,
    y1: 30.01332,
    x2: 141.32661,
    y2: 21.46752,
    id: "Stroke-19",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.32655,
    y1: 21.4674,
    x2: 132.82365,
    y2: 12.918,
    id: "Stroke-21",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52411,31.81185 C71.52411,32.55255 71.14041,33.15315 70.66341,33.15315 C70.19001,33.15315 69.80271,32.55255 69.80271,31.81185 C69.80271,31.06785 70.19001,30.46725 70.66341,30.46725 C71.14041,30.46725 71.52411,31.06785 71.52411,31.81185 Z",
    id: "Stroke-23",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.19881,-0.00018 C36.75321,2.36322 39.04401,5.59332 37.31301,11.17332 C34.89681,18.96252 30.49401,21.51522 28.02861,27.13512 C26.19201,31.32102 22.22631,38.49012 32.20821,51.47742",
    id: "Stroke-25",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12762,-0.00018 C104.57322,2.36322 102.28272,5.59332 104.01342,11.17332 C106.42962,18.96252 110.83242,21.51522 113.29812,27.13512 C115.13472,31.32102 119.10042,38.49012 109.11822,51.47742",
    id: "Stroke-27",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyWeight);
export default __webpack_public_path__ + "static/media/bodyWeight.7291f30d.svg";
export { ForwardRef as ReactComponent };